import { db } from "@/services/db/db.js";
import { isPreview } from "@/utils/tema-preview-listener";

const imagensPreCarregadas = new Set();

export default {
  data() {
    return {
      componentes: [],
      isLoading: true,
      isLoadingProducts: true,
      screen_atual: "",
      screen_xs: 520,
      screen_sm: 768,
      screen_md: 992,
      screen_lg: 1295,
    };
  },

  created() {
    window.addEventListener("resize", this.resize);
    this.resize();
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
  },

  methods: {
    async getComponentProdutos(componentesId) {
      if (this.produtosAbortController) this.produtosAbortController.abort();
      const controller = new AbortController();
      this.produtosAbortController = controller;

      const params = { componente_id: componentesId };
      const dadosPedido = this.$store.getters.dadosPedido;
      if (dadosPedido && dadosPedido.pedidoId) {
        params.pedido_id = dadosPedido.pedidoId;
      }

      try {
        this.isLoadingProducts = true;
        const url = `${process.env.VUE_APP_ECOMMERCE}${api.env.BUSCA_COMPONENTES_PRODUTOS}`;
        const { data } = await AglAxios.connection().post(url, params, {
          signal: controller.signal,
        });
        if (controller !== this.produtosAbortController) return;
        if (!data.error) {
          if (data.componentes_produtos.length > 0) {
            data.componentes_produtos.forEach((componente_produto) => {
              if (componente_produto.produtos.length > 0) {
                const componenteIndex = this.componentes.findIndex(
                  (componente) =>
                    componente.componente_id == componente_produto.componente_id
                );

                if (componenteIndex != -1) {
                  const lista_produtos = [];
                  componente_produto.produtos.map((value) => {
                    if (
                      typeof value.possuiestoque !== "undefined" &&
                      value.possuiestoque == false
                    ) {
                      return;
                    }
                    lista_produtos.push(this.montaVariavelDeProduto(value));
                  });
                  this.componentes[componenteIndex].produtos = lista_produtos;
                  this.componentes[componenteIndex].isLoading = false;

                  // Em preview, persistir produtos em Vuex allComponents. Sem
                  // isso, mutation temaPreviewUpdateComponent do listener (edit
                  // de qualquer componente) dispara watcher storeComponents →
                  // processComponents que clona allComponents sem produtos →
                  // guard hasProdutos falha → refetch. Em uso normal (sem
                  // preview) mantemos o comportamento do master: produtos só
                  // em data local, sem custo extra de watcher re-fire.
                  if (isPreview()) {
                    this.$store.commit("temaPreviewUpdateComponent", {
                      componenteId: componente_produto.componente_id,
                      payload: { produtos: lista_produtos },
                    });
                  }
                }
              }
            });
          }
        } else {
          throw new Error(data.message);
        }
      } catch (error) {
        if (
          error &&
          (error.code === "ERR_CANCELED" || error.name === "CanceledError")
        )
          return;
        console.log(error);
      } finally {
        if (controller === this.produtosAbortController) {
          this.produtosAbortController = null;
          this.isLoadingProducts = false;
        }
      }
    },

    processComponents(sourceComponents) {
      const produtos_componentes = [];
      const source = sourceComponents || [];
      const componentes =
        typeof structuredClone === "function"
          ? structuredClone(source)
          : JSON.parse(JSON.stringify(source));

      componentes.forEach((componente, index) => {
        if (componente.tipo_id == 6) {
          // Só resetar + fetch se produtos vierem vazios. Fetch do backend
          // normal (BUSCA_COMPONENTES_EC) NÃO retorna produtos — eles vêm
          // via BUSCA_COMPONENTES_PRODUTOS separado. Então em uso normal,
          // produtos sempre chega vazio aqui e o fetch sempre roda. Em
          // modo preview, mutations do temaPreviewUpdateComponent mantém
          // produtos (seja admin injetando ou preservando existentes), e
          // processComponents seria chamado pra QUALQUER mudança em
          // allComponents — mesmo edição de componente não-tipo-6. Sem este
          // guard, editar um slider faria TODOS os tipos 6 da página
          // refetcharem produtos em loop (flash visual no iframe).
          const hasProdutos =
            Array.isArray(componente.produtos) &&
            componente.produtos.length > 0;
          if (!hasProdutos) {
            componentes[index].isLoading = true;
            componentes[index].produtos = [];
            produtos_componentes.push(componente.componente_id);
          }
        }

        db.componente
          .where("componente_id")
          .equals(componente.componente_id)
          .first()
          .then((componente_db) => {
            if (componente_db) {
              db.componente.update(componente.componente_id, componente);
            } else {
              db.componente.add(componente);
            }
          });
      });

      componentes.forEach((componente) => {
        if (!Array.isArray(componente.produtos)) componente.produtos = [];
        componente.imagens_validas = componente.imagens_validas || [];
        componente.imagens_validas.forEach((imagem, i) => {
          imagem.src = this.getImageSrc(imagem.tamanhos);
          if (
            componente.tipo_id == 1 &&
            i == 0 &&
            imagem.src &&
            !imagensPreCarregadas.has(imagem.src)
          ) {
            imagensPreCarregadas.add(imagem.src);
            const link = document.createElement("link");
            link.rel = "preload";
            link.as = "image";
            link.href = imagem.src;
            document.head.appendChild(link);
          }
        });
      });

      this.componentes = componentes;
      this.isLoading = false;

      if (produtos_componentes.length > 0) {
        this.getComponentProdutos(produtos_componentes);
      }
    },

    montaVariavelDeProduto(value) {
      if (this.$store.getters.carrinhoAtual.length) {
        const itemAdicionado = this.$store.getters.carrinhoAtual.find(
          (p) => p.id === value.produto_id
        );
        value.qtd = itemAdicionado ? itemAdicionado.qtd : 0;
      } else {
        value.qtd = 0;
      }

      return {
        cod_produto: value.id,
        fornecedor: value.fornecedor_id,
        categoria: value.categoria_id,
        descricao: value.descricao,
        link: "./",
        src: value.src,
        valor: Number(value.vlrproduto),
        vlrstdesonerado: Number(value.vlrstdesonerado),
        vlrbruto: Number(
          value.vlrproduto + value.vlrst - value.vlrdesc - value.vlrstdesonerado
        ),
        vlrst: Number(value.vlrst),
        vlrdesconto: Number(value.vlrdesc),
        vlracresc: value.vlracresc,
        possuiestoque: value.possuiestoque,
        qtd: value.qtd,
        embqtdean: value.embqtdean,
        embqtddun14: value.embqtddun14,
        embtpdun14: value.embtpdun14,
        integracao_id: value.integracao_id,
        codigo_exibicao: value.codigo_exibicao,
        hasprodbloq: value.hasprodbloq,
        ean: value.ean,
        embeantext: value.embeantext,
        hascondbloq: value.hascondbloq,
        promocaomaxdesconto: value.promocaomaxdesconto || 0,
        haspromocaocampanha: value.haspromocaocampanha || false,
        promocao: value.promocao || null,
        grupo: value.grupo,
        displayDescontoPct: value.displayDescontoPct,
        decim: value.decim,
        decim_num_casas: value.decim_num_casas,
        faixas_desconto: value.faixas_desconto,
        faixa_status: value.faixa_status,
      };
    },

    updateComponenteData() {
      this.componentes.forEach((componente) => {
        if (!Array.isArray(componente.imagens_validas)) return;
        componente.imagens_validas.forEach((imagem) => {
          imagem.src = this.getImageSrc(imagem.tamanhos);
        });
      });
    },

    getImageSrc(tamanhos) {
      let src = "";

      for (let i = 0; i < tamanhos.length; i++) {
        if (tamanhos[i].tipo == this.screen_atual) {
          src = `${tamanhos[i].nome_img}`;
          break;
        }
      }
      if (src == "") {
        switch (this.screen_atual) {
          case "D":
            tamanhos.forEach((tamanho) => {
              if (tamanho.tipo == "T") src = `${tamanho.nome_img}`;
            });
            if (src == "") {
              tamanhos.forEach((tamanho) => {
                if (tamanho.tipo == "M") src = `${tamanho.nome_img}`;
              });
            }
            break;
          case "T":
            tamanhos.forEach((tamanho) => {
              if (tamanho.tipo == "M") src = `${tamanho.nome_img}`;
            });
            if (src == "") {
              tamanhos.forEach((tamanho) => {
                if (tamanho.tipo == "D") src = `${tamanho.nome_img}`;
              });
            }
            break;
          case "M":
            tamanhos.forEach((tamanho) => {
              if (tamanho.tipo == "T") src = `${tamanho.nome_img}`;
            });
            if (src == "") {
              tamanhos.forEach((tamanho) => {
                if (tamanho.tipo == "D") src = `${tamanho.nome_img}`;
              });
            }
            break;
          default:
            break;
        }
      }
      return src;
    },

    resize() {
      const width = $(window).width();
      if (width <= this.screen_xs) {
        this.screen_atual = "M";
      } else if (width <= this.screen_sm) {
        this.screen_atual = "T";
      } else {
        this.screen_atual = "D";
      }
      this.updateComponenteData();
    },
  },
};
